import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {ExtraSalesSummaryReportModel} from "./extra-sales-summary-report.model";

@Component({
    selector: "wbo-extra-sales-summary-report-page",
    templateUrl: "./extra-sales-summary-report-page.component.html",
    providers: [provideReportModel(ExtraSalesSummaryReportModel)]
})
export class ExtraSalesSummaryReportPageComponent extends AbstractReportPage {
    constructor(public model: ExtraSalesSummaryReportModel) {
        super();
    }
}
